var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstructionProLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261153333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M33.3817 28.7103L20.0699 5.79111L3.69407 34.0335L6.09759 38.1717L19.8963 13.5547L28.7708 28.8341L33.3817 28.7103Z",
    fill: "#3B98D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M6.83705 39.444L19.5988 16.7063L22.0023 20.8445L13.8401 35.3765L41.0536 35.3217L38.8462 39.5837L6.83705 39.444Z",
    fill: "#3B98D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M42.4608 34.0797L26.1909 6.06739L21.3951 5.87288L35.4465 30.0654L18.4612 30.1394L16.5722 34.2165L42.4608 34.0797Z",
    fill: "#3B98D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionProLogo);
export default __webpack_public_path__ + "static/media/construction_pro_logo.8e460495decd865a94f3c78baaa0764e.svg";
export { ForwardRef as ReactComponent };